import {
	GuestResource,
	RegistrationFormStepResource,
	RuleGuestAttributeResourceTypeDataField,
	RuleGuestAttributeResourceTypeRelation,
	RuleResource,
	RuleSetResource,
} from "../../../shared/types";
import { ActionTypes } from "../../../shared/types/actions";
import { FilledSteps } from "../../provider/registrationFormProviderContext";
import { validateDataField } from "../dataField";
import { validateRelation } from "../relation";

export interface RuleResult {
	id: number | string;
	show: boolean;
}

const validateRule = (
	rule: RuleResource<RuleGuestAttributeResourceTypeRelation> | RuleResource<RuleGuestAttributeResourceTypeDataField>,
	dataFieldValues: Record<number, any>,
	guest: GuestResource | null,
	filledSteps: FilledSteps,
	steps: RegistrationFormStepResource[],
): boolean => {
	switch (rule.guestAttribute.type) {
		case "relation":
			return validateRelation(rule as RuleResource<RuleGuestAttributeResourceTypeRelation>, guest, filledSteps, steps);
		case "dataField":
			return validateDataField(rule as RuleResource<RuleGuestAttributeResourceTypeDataField>, dataFieldValues, true);
	}
};

export const areAllRulesValid = (
	ruleSet: RuleSetResource,
	dataFieldValues: Record<number, any>,
	guest: GuestResource | null,
	filledSteps: FilledSteps,
	steps: RegistrationFormStepResource[],
): boolean => {
	return ruleSet.isAndLinked
		? ruleSet.rules.every((rule) => validateRule(rule, dataFieldValues, guest, filledSteps, steps))
		: ruleSet.rules.some((rule) => validateRule(rule, dataFieldValues, guest, filledSteps, steps));
};

const evaluateRuleSetForType =
	(type: ActionTypes) =>
	(
		ruleSet: RuleSetResource,
		dataFieldValues: Record<number, any>,
		guest: GuestResource | null,
		filledSteps: FilledSteps,
		steps: RegistrationFormStepResource[],
	): RuleResult[] => {
		const show = areAllRulesValid(ruleSet, dataFieldValues, guest, filledSteps, steps);

		return ruleSet.actions
			.filter((action) => action.type === type)
			.map((action) => {
				switch (action.type) {
					case ActionTypes.SHOW_DATA_FIELD:
						return { id: `${action.value.section.id}-${action.value.dataField.id}`, show };
					case ActionTypes.SHOW_SECTION:
						return { id: action.value.id, show };
					case ActionTypes.SHOW_STEP:
						return { id: action.value.id, show };
					case ActionTypes.SHOW_BLOCK:
						return {
							id: action.value.sectionId ? `${action.value.sectionId}-${action.value.id}` : action.value.id,
							show,
						};
				}
			});
	};

export const evaluateRuleSetForSteps = evaluateRuleSetForType(ActionTypes.SHOW_STEP);
export const evaluateRuleSetForSections = evaluateRuleSetForType(ActionTypes.SHOW_SECTION);
export const evaluateRuleSetForDataFields = evaluateRuleSetForType(ActionTypes.SHOW_DATA_FIELD);
